module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-meet-team"
  }, [_c('div', {
    staticClass: "custom-meet-team__container"
  }, [_c('div', {
    staticClass: "custom-meet-team__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-meet-team__staff"
  }, _vm._l((_vm.props.staff), function(item, i) {
    return _c('div', {
      staticClass: "custom-meet-team__card",
      on: {
        "click": function($event) {
          return _vm.showModal(6, item)
        }
      }
    }, [_c('div', {
      staticClass: "custom-meet-team__image",
      style: ({
        backgroundImage: 'url(' + item.image + ')'
      })
    }), _c('div', {
      staticClass: "custom-meet-team__image--hover",
      style: ({
        backgroundImage: 'url(' + item.hover + ')'
      })
    }, [_c('div', {
      staticClass: "custom-meet-team__bio"
    }, [_c('div', {
      staticClass: "custom-meet-team__name",
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }), _c('div', {
      staticClass: "custom-meet-team__position",
      domProps: {
        "innerHTML": _vm._s(item.position)
      }
    }), _c('div', {
      staticClass: "custom-meet-team__link"
    }, [_vm._v("Read More")])])])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ebde809","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-meet-team/custom-meet-team.pug
// module id = 656
// module chunks = 1